export class EventManager {
  constructor(socket) {
    this.socket = socket;
    this.localListeners = {};
  }

  server = {
    on: (eventName, callback) => {
      this.socket.on(eventName, callback);
    },
    off: (eventName, callback) => {
      this.socket.off(eventName, callback);
    },
  };

  local = {
    on: (eventName, callback) => {
      if (typeof callback !== 'function') {
        console.warn(`EventManager: Attempted to register non-function listener for event '${eventName}'`, callback);
        return;
      }
      if (!this.localListeners[eventName]) {
        this.localListeners[eventName] = [];
      }
      this.localListeners[eventName].push(callback);
    },
    off: (eventName, callback) => {
      if (this.localListeners[eventName]) {
        this.localListeners[eventName] = this.localListeners[eventName].filter(
          (cb) => cb !== callback
        );
      }
    },
    emit: (eventName, ...args) => {
      this.fireLocal(eventName, ...args);
    },
  };

  fireLocal = (eventName, ...args) => {
    if (this.localListeners[eventName]) {
      this.localListeners[eventName].forEach((callback) => {
        try {
          if (typeof callback === 'function') {
            callback(...args);
          }
        } catch (error) {
          console.error(`Error in local event listener for ${eventName}`, error);
        }
      });
    }
  };
}